module.exports = __webpack_public_path__ + "img/prop-rock-1-right.6706fc66.png";